<template>
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
  <div id="container"  class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->

 
  <iframe src="3dmap/index1.html" style="width:100%;height:100%;border: none;"></iframe>
  <!-- 顶部 -->
  <div class="navBox"><Nav curNavId="7" pathUrl='suyuan' @circle="clickNav" /></div>
  <!-- 左边 -->
  <div class="left">
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />主要虫害</div>
  <div class="borderBox leftBox1">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" id="tabs">
      <el-tab-pane v-for="(item,index) in leftData1" :key="index"  :label="item.name" :name="index">
        <div class="leftCon animate__animated animate__fadeInLeft" >
          <div class="leftDataTop">
              <img :src="item.img" />
              <div class="leftDataTopRight">
                <h4>{{item.name}}</h4>
                <p v-html="item.info"></p>
              </div>
            </div>
            <div class="leftDataBottom">
              <h4>[ 防治方法 ]</h4>
              <p class="leftContent" v-html="item.fangzhi"></p>  
            </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
  <div class="borderBox leftBox2" v-if="leftData1[curLeftIndex].data[0].mc!=''">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <leftBar1 :leftData1="leftData1[curLeftIndex].data" v-if="showDiv" />
  </div>
</div>
<!-- 右侧 -->
<div class="right">
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />虫情检测</div>
  <div class="borderBox rightBox1">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <div class="imgItem" v-for="(item,index) in rightData1" :key="index">
      <div class="imgItemBg"><img :src="item.img" /></div><p>{{item.date}}</p></div>
  </div>
  <div class="title"><img src="../assets/img/gbzntyj/bingchong/titIcon.png" class="titIcon" />虫情发现</div>
  <div class="borderBox rightBox2">
    <div class="contentLine contentLine1"></div>
    <div class="contentLine contentLine2"></div>
    <div class="contentLine contentLine3"></div>
    <div class="contentLine contentLine4"></div>
    <div class="subTit"> <span>设备ID</span><span>设备名称</span><span>害虫名称</span> </div>
    <div class="rightContent2"><dv-scroll-board :config="config" style="width:100%;height:100%" /></div>
  </div>
</div>
 </div>
 <footer1 />

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
} from "vue";

import Nav from "../components/nav.vue";
import leftBar1 from "@/components/binghai/leftBar1.vue";
import footer1 from "../components/footer.vue";
import CircleNav from "@/components/circleNav.vue";
import {getRandomDate} from "@/utils/getRandomDate";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const mapRef = ref(null);
    const activeName = ref(0)
    const state = reactive({
      leftData1:[
        {name:"麦蚜虫",img:require("@/assets/img/gbzntyj/bingchong/img.jpg"),
          info:"俗称油虫、腻虫、蜜虫，是小麦的主要害虫之一，可对小麦进行刺吸危害，影响小麦光合作用及营养吸收、传导。",
          fangzhi:"拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(1)拌种。播种前用种衣剂加新高脂膜拌种，可驱避地下病虫，隔离病毒感染，不影响萌发吸胀功能，加强呼吸强度，提高种子发芽率。(2)冬麦适当晚播，实行冬灌，早春耙磨镇压。作物生长期间，要根据作物需求施肥、给水，保证NPK和墒情匹配合理，以促进植株健壮生长。雨后应及时排水，防止湿气滞留。在孕穗期要喷施壮穗灵，强化作物生理机能，提高授粉、灌浆质量，增加千粒重，提高产量。(3)药剂防治注意抓住防治适期和保护天敌的控制作用。要抓好秋苗期、拔节期以及穗期蚜虫的防治，每亩可选用50%抗蚜威可湿性粉剂10-15克（4000倍液）或10%吡虫啉10-15克（1000倍）或50%辛硫磷乳油2000倍或2.5%三氟氯氰菊酯20-25克兑水50公斤喷雾防治。如小麦白粉病同时发生，每亩可用粉锈宁有效成分6克+灭幼脲有效成分2克喷雾防治。",
          data:[
            {"mc":"","dysl":"84","sysl":"77",yc:"80"},
            {"mc":"","dysl":"76","sysl":"83",yc:"80"},
            {"mc":"","dysl":"88","sysl":"76",yc:"80"},
            {"mc":"","dysl":"78","sysl":"80",yc:"76"},
            {"mc":"","dysl":"70","sysl":"70",yc:"80"},
            {"mc":"","dysl":"80","sysl":"81",yc:"80"},
          ]
        },
        {name:"麦蜘蛛",img:require("@/assets/img/gbzntyj/bingchong/img3.jpg"),
          info:"国内危害小麦的螨类主要由麦圆蜘蛛与麦长腿蜘蛛两种。前者属真足螨科。麦圆蜘蛛发生在北纬37度至29之间的冬麦区；麦长腿蜘蛛分布偏北，主要发生在北纬34至43度的小麦产区。在安徽省多数地区发生危害的是麦圆蜘蛛，皖北部地区如砀山，两种麦蜘蛛混合发生。两种麦蜘蛛主要危害小麦，大麦受害轻。麦蜘蛛在小麦苗期吸食叶汁液。被害叶上初现许多细小白斑，以后麦叶变黄。麦株受害后轻者影响生长，植株矮小，产量降低，重者全株干枯死亡。麦圆蜘蛛危害盛期在小麦拔节阶段，小麦受害后如及时浇水追肥，可显著减轻受害程度。麦长腿蜘蛛危害盛期在小麦孕穗至抽穗期，大可发生时可造成严重减产。",
          fangzhi:"防治方法：1、农业防治。实行倒茬轮作，及时清理田间地头杂草、可减轻麦蜘蛛为害。浇水振落，淹死部分蜘蛛。2、早防早治。在麦蜘蛛发生早期，进行田间点片挑治，采取“灭虫源，控点片，发现一株治一圈，发现一点治一片”的方法，消灭田边、地头杂草上的虫源，防治其进一步扩散蔓延。3、药剂喷雾。用40%乐果乳油1000倍液喷雾，或20%哒蟠灵10001500倍液，或50%马拉硫磷2000倍液喷雾防治，对麦长腿蜘蛛和麦圆蜘蛛均有较好防治效果。药液重点喷在麦叶背面，同时兼顾全株，套种作物也一并喷到。4、撒施毒土。每亩用40%乐果乳油50克，对等量水均匀拌人1015千克细砂土内，配制成乐果毒土，顺垄撒施。",
          data:[
            {"mc":"4.1","dysl":"84","sysl":"77",yc:"80"},
            {"mc":"4.5","dysl":"76","sysl":"83",yc:"80"},
            {"mc":"4.7","dysl":"88","sysl":"76",yc:"80"},
            {"mc":"4.9","dysl":"78","sysl":"80",yc:"80"},
            {"mc":"4.12","dysl":"70","sysl":"70",yc:"80"},
            {"mc":"4.15","dysl":"80","sysl":"81",yc:"80"},
          ]
        },
        {name:"麦叶蜂",img:require("@/assets/img/gbzntyj/bingchong/img4.jpg"),
          info:"属于膜翅目，叶蜂总科，叶蜂科，世界记载共约170种。以幼虫危害麦叶，从叶边缘向内咬成缺刻，严重时可将全部叶尖吃掉。影响了小麦的光合作用，造成小麦的产量下降。成虫夜间潜伏在麦苗基部或浅土中, 白天活动、交配、产卵, 有假死性。麦叶蜂以幼虫为害麦叶，从叶边缘向内咬成缺刻，重者可将叶尖全部吃光。初孵幼虫多在其附近较矮的麦苗心叶或嫩叶上取食, 为害成缺刻或短条, 宽度为0.3-0.5mm;2 龄幼虫为害宽度为1-1.8mm; 3 龄1~ 3mm, 并出现似剪刀横断的为害状; 5龄幼虫咬食宽度可达8mm。3龄前多集中在下部叶片或比较矮的无效分蘖上取食, 3 龄以后始为害有效分孽的上部叶片，且食量在四龄以后迅速大幅度增长。",
          fangzhi:"1.水旱轮作。有条件的地区可实行水旱轮作，进行稻麦、倒茬，即可控制麦叶蜂的为害。2.播前深耕。在小麦播种前进行深耕，把土壤中休眠的幼虫翻出，使其因不能正常化蛹而死亡。3.人工捕杀。利用麦叶蜂成虫和幼虫的假死性，在傍晚时分用捕虫网或簸箕进行捕杀。",
          data:[
            {"mc":"4.1","dysl":"84","sysl":"77",yc:"80"},
            {"mc":"4.5","dysl":"76","sysl":"83",yc:"80"},
            {"mc":"4.7","dysl":"88","sysl":"76",yc:"80"},
            {"mc":"4.9","dysl":"78","sysl":"80",yc:"80"},
            {"mc":"4.12","dysl":"70","sysl":"70",yc:"80"},
            {"mc":"4.15","dysl":"80","sysl":"81",yc:"80"},
          ]
        },
        {name:"蝼蛄",img:require("@/assets/img/gbzntyj/bingchong/img5.jpg"),
          info:"蝼蛄俗名拉拉蛄，地拉蛄，天蝼，土狗等。我国大陆上常见的分布较广的蝼蛄有4种，分别是华北蝼蛄、东方蝼蛄、金秀蝼蛄、河南蝼蛄和台湾蝼蛄。蝼蛄一年的生活分6个阶段：冬季休眠、春季苏醒、出窝迁移、猖獗危害、越夏产卵、秋季危害。",
          fangzhi:"1、种子处理：用50%辛硫磷乳油0.3 kg拌种100 kg，可防治蝼蛄等多种地下害虫，不影响发芽率。使用70%锐胜可分散性种子处理剂进行拌种，其种子表面有保护层，可有效地保护萌发种子不受侵害。 2、发生期防治:当发现有成、若虫危害时，喷施有机磷或菊酯类杀虫剂。如土中根施3%氟菊酯颗粒剂、根灌50%辛硫磷乳剂1000倍液防治、使用70%锐劲特（氟虫腈）悬浮剂2000倍液灌床防治等。",
          data:[
            {"mc":"4.1","dysl":"84","sysl":"77",yc:"80"},
            {"mc":"4.5","dysl":"76","sysl":"83",yc:"80"},
            {"mc":"4.7","dysl":"88","sysl":"76",yc:"80"},
            {"mc":"4.9","dysl":"78","sysl":"80",yc:"80"},
            {"mc":"4.12","dysl":"70","sysl":"70",yc:"80"},
            {"mc":"4.15","dysl":"80","sysl":"81",yc:"80"},
          ]
        },
        {name:"地老虎",img:require("@/assets/img/gbzntyj/bingchong/img6.jpg"),
        info:"地老虎，昆虫名，属夜蛾科。世界约2万种，中国约1600种。成虫口器发达，多食性作物害虫。种类很多，农业作物造成危害的有10余种。其中小地老虎、黄地老虎、大地老虎、 白边地老虎和警纹地老虎等尤为重要，均以幼虫为害。",
        fangzhi:"1、种子处理：可用60%吡虫啉悬浮种衣剂按照药种比1:200～400比例进行拌种，可有效防治蛴螬、蝼蛄、金针虫、地老虎等地下害虫，通过内吸传导作用，将药剂传输到地上部分，还可兼治蚜虫、蓟马、飞虱等地上害虫。 2、土壤处理：可用 75％辛硫磷拌成毒土或毒砂，撒施 20～30 kg/亩，或用 50％辛硫磷乳油 1 000 倍液、2.5％溴氰菊酯 3 000 倍液进行地面喷洒或喷在作物上。 3、苗期若出现地下害虫，可用化学药剂阿维哒螨灵、吡虫啉等杀虫剂进行防治，降低虫口密度。",
        data:[
          {"mc":"4.1","dysl":"80","sysl":"89",yc:"20"},
          {"mc":"4.5","dysl":"75","sysl":"107",yc:"70"},
          {"mc":"4.8","dysl":"40","sysl":"61",yc:"60"},
          {"mc":"4.10","dysl":"90","sysl":"90",yc:"58"},
          {"mc":"4.15","dysl":"43","sysl":"71",yc:"49"},
          {"mc":"4.18","dysl":"56","sysl":"100",yc:"26"},
        ]
        },
        {name:"金针虫",img:require("@/assets/img/gbzntyj/bingchong/img7.jpg"),
        info:"金针虫是叩头虫的幼虫，危害植物根部、茎基、取食有机质，中国的主要种类有沟金针虫、细胸金针虫、褐纹金针虫、宽背金针虫、兴安金针虫、暗褐金针虫等。",
        fangzhi:"1、种子处理：可用60%吡虫啉悬浮种衣剂按照药种比1:200～400比例进行拌种，可有效防治蛴螬、蝼蛄、金针虫、地老虎等地下害虫，通过内吸传导作用，将药剂传输到地上部分，还可兼治蚜虫、蓟马、飞虱等地上害虫。 2、土壤处理：可用 75％辛硫磷拌成毒土或毒砂，撒施 20～30 kg/亩，或用 50％辛硫磷乳油 1 000 倍液、2.5％溴氰菊酯 3 000 倍液进行地面喷洒或喷在作物上。 3、苗期和生长期症状明显时及时割除发病植株，并带出田外深埋。",
        data:[
          {"mc":"4.1","dysl":"84","sysl":"77",yc:"80"},
          {"mc":"4.5","dysl":"76","sysl":"83",yc:"80"},
          {"mc":"4.8","dysl":"88","sysl":"76",yc:"80"},
          {"mc":"4.10","dysl":"78","sysl":"80",yc:"80"},
          {"mc":"4.15","dysl":"70","sysl":"70",yc:"80"},
          {"mc":"4.18","dysl":"80","sysl":"81",yc:"80"},
        ]
        },
      ],
      curLeftIndex:0,
      showDiv:true,
      rightData1:[
        {date:"2024.4.18",img:require("@/assets/img/gbzntyj/bingchong/cq1.jpg")},
        {date:"2024.4.20",img:require("@/assets/img/gbzntyj/bingchong/cq2.jpg")},
        {date:"2024.4.26",img:require("@/assets/img/gbzntyj/bingchong/cq3.jpg")},
        {date:"2024.4.30",img:require("@/assets/img/gbzntyj/bingchong/cq4.jpg")},
        {date:"2024.5.03",img:require("@/assets/img/gbzntyj/bingchong/cq5.jpg")},
        {date:"2024.5.06",img:require("@/assets/img/gbzntyj/bingchong/cq6.jpg")}
      ],
      config: {
        // header: ['<span style="color:#038259;">网上名称</span>', '<span style="color:#038259;">归属地</span>', '<span style="color:#038259;">店铺数据</span>'],
        data: [
          ["866547052737130", "测报灯", "棉铃虫"],
          ["866547052737130", "测报灯", "粘虫、小地老虎"],
          ["866547052737130", "测报灯", "小地老虎"],
          ["866547052737130", "测报灯", "小地老虎"],
          ["866547052737130", "测报灯", "粘虫"],
          ["866547052737130", "测报灯", "小地老虎"],
          ["866547052737130", "测报灯", "黄地老虎"],
          ["866547052737130", "测报灯", "斜纹夜蛾"],
          ["866547052737130", "测报灯", "黄地老虎"],
        ],
        headerBGC: "",
        oddRowBGC: "",
        evenRowBGC: "",
        // index: true,
        // columnWidth: [150],
        align: ["center"],
        // rowNum:6
      },
      circleShow:false

    });

    const clearLocalStorage = (name) => {
      localStorage.removeItem(name);
      console.log("清除")
    };
    let intervalId = null;
    // 左侧折线图 获取日期
    function getDate(numDays,type,name){
      console.log(type)
      let dateArr=[]
      let recentDate = localStorage.getItem(name);
      // console.log(recentDate)
      if(recentDate){
        dateArr = recentDate.split(',')
      }else{
        const daysAgo = ref(numDays,type);
        const recentDate = getRandomDate(daysAgo.value,type);
        // console.log(recentDate)
        localStorage.setItem(name, recentDate);
        // console.log(localStorage.getItem(name))
        intervalId = setInterval(clearLocalStorage(name), 3 * 24 * 60 * 60 * 1000);
        dateArr = recentDate
      }
      return dateArr
    }
    // 在 onMounted 中初始化地图
    onMounted(() => {
      // 虫害左侧柱状图时间
      let dateArr = getDate(6,1,'binghaiDate1')
      // console.log(dateArr)
      let leftData1 = state.leftData1
      leftData1.forEach(item=>{
        let data = item.data
        for(var i=0;i<data.length;i++){
          // console.log(data[i])
          data[i].mc = dateArr[i]
        }
        // console.log(data)
      })
      // 虫情检测时间
      let dateArr1 = getDate(6,2,'binghaiDate2')
      // console.log(dateArr1)
      for(var i=0;i<state.rightData1.length;i++){
        // console.log(data[i])
        state.rightData1[i].date = dateArr1[i]
      }

    });


    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }


    function handleClick (tab,e){
      // console.log(tab.index)
      
      state.showDiv = false; // 点击后先隐藏div
      state.curLeftIndex = tab.index
      setTimeout(() => {
        state.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    onUnmounted(() => {
      // 清除定时器
      if (intervalId) {
        clearInterval(intervalId);
      }
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      mapRef,
      clickReturn,
      activeName,
      handleClick,
      clickNav,
      circleHiddlen
    };
  },
  components: {
    CircleNav,
    Nav,
    footer1,
    leftBar1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .d-play-btn {
  width: 50px !important;
  height: 50px !important;
}
::v-deep .d-player-state{
  top: 50%;
  margin-top: -25px;
}
::v-deep .d-icon{
  font-size: 20px!important;
}
::v-deep .d-player-wrap .d-player-control{
  height: 30px;
}
// /* 隐藏水平滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__horizontal {
//   display: none!important;
// }
 
// /* 隐藏垂直滚动条 */
// .leftBox1::v-deep .uni-scroll-bar__vertical {
//   display: none;
// }

.navBox{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 95px;
  background: linear-gradient( to bottom, rgba(0, 0, 0, 0.8) 0%,  rgba(0, 0, 0, 0.7) 50%,  rgba(0, 0, 0, 0));
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  overflow: hidden;
  .containerBg{
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }
}





  // .content{
  //   width: 100%;
    
  //   display: flex;
  //   justify-content: space-between;
  //   padding: 0 24px;
  //   box-sizing: border-box;
  //   z-index: 999;
  //   }
.left,.right{
  width: 572px;
  height: 100%;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  padding-top: 80px;
  box-sizing: border-box;
}
.title{
  background: url("../assets/img/gbzntyj/bingchong/btk.png") no-repeat;
  width: 557px;
  height: 45px;
  line-height: 45px;
  padding-left: 10px;
  font-size: 18px;
  color: #fff;
  text-align: left;
  display: flex;
  .titIcon{
    display: block;
    width: 12px;
    height: 12px;
    margin-top: 16px;
    margin-right: 10px;
    animation: titIcon 5s linear infinite;
  }
  
}
.borderBox{
  border: 1px solid #165752;
  box-shadow: inset 0 0 20px 16px rgba(26, 91,85,.5);
  padding: 20px;
  box-sizing: border-box;
  background: rgba(0,0,0,.15);
  position: relative;
  overflow: hidden;
}
.left{
  left: 0;
  padding-left: 24px;
  background:url("../assets/img/gbzntyj/gaungai/zjb.png") no-repeat ;
  .leftBox1{
    width:100%;
    height:480px;
    margin: 10px 0;
    .leftTit{
      display: flex;
      overflow-x: auto;
      scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
      width: 100%;
      height: 36px;
      font-size: 16px;
      color: #fff; 
    }
    .leftCon{
      width: 100%;
      flex: 1;
    }
    .leftDataTop{
      display: flex;
      height: 93px;
      margin: 10px 0 10px;
      img{
        width: 109px;
        height: 93px;
        margin: 0 20px 0 10px;
      }
      .leftDataTopRight{
        flex: 1;
        height: 100%;
        overflow: hidden;
        text-align: left;
        color: #fff;
        font-size: 14px;
        line-height: 20px;
        margin-right: 20px;
        justify-content: space-between;
        h4{
          flex: 1;
          margin: 0 0 8px;
        }
        p{
          height: 60px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
     }
     .leftDataBottom{
      text-align: left;
      color: #fff;
      line-height: 24px;
      padding: 0 16px;
      font-size: 14px;
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      h4{
        height: 36px;
        line-height: 36px;
      }
      .leftContent{
        width: 100%;
        height: 240px;
        scrollbar-width: none;
        -ms-overflow-style: none;
        overflow-x: hidden;
        overflow-y: auto;
      }
     }
  }
  .leftBox2{
    flex: 1;
  }
}
.right{
  right: 0;
  background:url("../assets/img/gbzntyj/gaungai/yjb.png") no-repeat ;
  padding-right: 24px;
  .rightBox1{
    width: 100%;
    height: 360px;
    margin: 10px 0 30px;
    padding: 20px 30px 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .imgItem{
      margin: 0 10px;
      width: 127px;
      height: 138px;
      .imgItemBg{
        width:127px ;
        height: 112px;
        background: url("../assets/img/gbzntyj/bingchong/imgBg.png") no-repeat ;
        padding: 5px;
        box-sizing: border-box;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      p{
          color: #fff;
          font-size: 14px;
          line-height: 24px;
        }
    }
    
  }
  .rightBox2{
    width: 100%;
    flex: 1;
    margin: 10px 0 0;
    display: flex;
    flex-direction: column;
    .subTit{
      width: 100%;
      height: 37px;
      background: linear-gradient(to right, rgba(32, 156, 256, 0),rgba(32, 156, 256, 0.1), rgba(104, 224, 207, 0.2), rgba(0, 135, 240, 0.1), rgba(0, 135, 240, 0));
      font-size: 16px;
      line-height: 37px;
      color: #fff;
      display: flex;
      span{
        display: block;
        flex: 1;
      }
    }
    .rightContent2{
      width: 100%;
      flex: 1;
    }
  }
}
    
 ::v-deep .row-item{
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(255,255,255,0.05)10%,rgba(255,255,255,0.2),rgba(255,255,255,0.05))1;
}
  // 左侧1 tab


 ::v-deep .el-tabs__item{
  width: 104px;
  height: 36px;
  padding: 0;
  border: 1px solid #1A6266;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
}
::v-deep  .el-tabs__item::before,::v-deep .el-tabs__item::after{
    content: " ";
    background: #21FCFF;
    width: 2px;
    height: 12px;
    position: absolute;
    top: 12px;
}
::v-deep .el-tabs__item::before{left:-1px}
::v-deep .el-tabs__item::after{right:-1px}
::v-deep .el-tabs__nav{ display: flex;}
::v-deep .el-tabs__nav-wrap::after{display: none;}
::v-deep .el-tabs__active-bar{width: 100%;background-color:#21FCFF;}
::v-deep .is-active{ color: #A1C81F;}


@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes titIcon {
  /*引用动画名称*/
  0% {
    transform: rotateY(0);
  }
  50% {
    transform: rotateY(180deg);
     animation-delay: 5s;
  }
  100% {
    transform: rotateY(0);
   
  }
}
.contentLine {
  background: #1AA19E;
  position: absolute;
}
.contentLine1{
  top: 0px;
  left: 0;
  width: 10%;
  height: 1px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1AA19E);
  animation: animate1 4s linear infinite;
}
.contentLine2{
  top: -100%;
  right: 0;
  width: 1px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1AA19E);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3{
  bottom: -1px;
  right: -100%;
  width: 20%;
  height: 1px;
  background: linear-gradient(270deg, transparent, #1AA19E);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4{
  bottom: -100%;
  left: 0px;
  width: 1px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1AA19E);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
0% {
      transform: rotate(0deg);
  }

100% {
  transform: rotate(-360deg);
}
}

@keyframes animate1 {
0% {
    left: -50%;
}

50%,
100% {
    left: 100%;
}
}

@keyframes animate2 {
0% {
    top: -100%;
}

50%,
100% {
    top: 100%;
}
}
@keyframes animate3 {
0% {
    right: -100%;
    height: 3px;
}

50%,
100% {
    height: 2px;
    right: 100%;
}
}
@keyframes animate4 {
0% {
    bottom: -100%;
}

50%,
100% {
    bottom: 100%;
}
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
